import { render, staticRenderFns } from "./Honour.vue?vue&type=template&id=a6f51a20&scoped=true"
import script from "./Honour.vue?vue&type=script&lang=js"
export * from "./Honour.vue?vue&type=script&lang=js"
import style0 from "./Honour.vue?vue&type=style&index=0&id=a6f51a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f51a20",
  null
  
)

export default component.exports